var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "info main_center" }, [
    _c("div", { staticClass: "top-content busWinessLeft" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "right-content clearfix busWinessRight",
        staticStyle: { top: "60px" },
      },
      [
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticStyle: { position: "relative", "margin-bottom": "24px" },
                attrs: { model: _vm.form, "label-width": "220px" },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "文件标题：",
                              size: "small",
                              prop: "title",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.title) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "内容：",
                              prop: "content",
                              size: "small",
                            },
                          },
                          [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(_vm.form.content) },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发布栏目：",
                              prop: "publishColumn",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.form.publishColumnName) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发布人：",
                              size: "small",
                              prop: "publishUser",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.publishUser) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  _vm._l(_vm.form.fileList, function (item, index) {
                    return _c(
                      "el-col",
                      { key: index, attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: item.fileTypeName
                                ? item.fileTypeName + "："
                                : "附件：",
                              prop: "attachments" + item.fileType,
                              size: "small",
                            },
                          },
                          [
                            _c("affix-msg", {
                              attrs: {
                                showDetail: true,
                                docItem: item,
                                docName: item.name,
                              },
                              on: {
                                "update:docItem": function ($event) {
                                  item = $event
                                },
                                "update:doc-item": function ($event) {
                                  item = $event
                                },
                                "update:docName": function ($event) {
                                  return _vm.$set(item, "name", $event)
                                },
                                "update:doc-name": function ($event) {
                                  return _vm.$set(item, "name", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }